<div class="main-content content-with-side-menu import-page">
    <h1 class="page-header">
        <app-go-back></app-go-back> {{ "CampImport.Title" | translate }}
    </h1>

    <div
        class="drop-container mt-2 d-flex"
        [ngClass]="{ 'drop-container-drag-over': dragOver }"
        ngFileDrop
        [options]="options"
        (uploadOutput)="onUploadOutput($event)"
        [uploadInput]="uploadInput"
    >
        <div class="row no-gutters align-self-center w-100">
            <div class="col text-center">
                {{ "CampImport.DragAndDrop" | translate }}
            </div>
        </div>
    </div>

    <div class="mt-2">
        {{ "CampImport.UseUploadButton" | translate }}
    </div>

    <div class="form-group mt-2">
        <input
            class="btn btn-primary"
            #inputFile
            accept=".xlsx, .xls"
            type="file"
            hznTestId="camp-import-file"
            ngFileSelect
            [options]="options"
            (uploadOutput)="onUploadOutput($event)"
            [uploadInput]="uploadInput"
        />
    </div>

    @if (fileSelected()) {
        <div class="mt-2">
            <ui-switch
                [checked]="isVisibleToMembers"
                (change)="onIsVisibleToMembersChanged($event)"
                class="switch"
                size="small"
                color="#346ABC"
                switchColor="white"
            ></ui-switch>
            {{ "CampImport.IsVisibletoMembersLabel" | translate }}
            {{ isVisibleToMembers | yesno }}
        </div>
    }

    @for (f of files; track f; let i = $index) {
        <div>
            <div class="row">
                <div class="col">
                    {{ f.name }}
                    <button
                        class="btn btn-danger btn-action ml-2"
                        type="button"
                        bcClick
                        (clicked)="removeFile(f.id)"
                    >
                        {{ "CampImport.RemoveLabel" | translate }}
                    </button>
                    <button
                        class="btn btn-success btn-action ml-1"
                        type="button"
                        bcClick
                        hznTestId="camp-import-start"
                        (clicked)="startUpload()"
                    >
                        {{ "CampImport.ImportLabel" | translate }}
                    </button>
                </div>
            </div>
        </div>
    }

    @if (importResult) {
        <div>
            <div class="mt-2">
                {{ "CampImport.SuccessLabel" | translate }}
                <strong
                    hznTestId="camp-import-success"
                    [ngClass]="{
                        'text-success': importResult.isSuccess,
                        'text-danger': !importResult.isSuccess,
                    }"
                    >{{ importResult.isSuccess }}</strong
                >
            </div>
            @if (importResult.isSuccess) {
                <div>
                    <p hznTestId="camp-import-message">
                        Camp {{ importResult.value.campName }} was successfully
                        imported !
                    </p>
                    <button
                        type="button"
                        class="btn btn-sm"
                        hznTestId="camp-import-view-camp"
                        (click)="goToDetails()"
                    >
                        {{ "CampImport.ViewCampLabel" | translate }}
                    </button>
                </div>
            }
            @if (importResult.validationNotification.errors.length > 0) {
                <div class="mt-2">
                    <div>
                        <strong class="text-danger"
                            >{{ "CampImport.ErrorsLabel" | translate }}
                        </strong>
                    </div>
                    <ul>
                        @for (
                            item of importResult.validationNotification.errors;
                            track item
                        ) {
                            <li hznTestId="camp-import-error">
                                <div>{{ item.message }}</div>
                                @if (
                                    showValidRevenueDepartmentHoldingAccountPairs()
                                ) {
                                    <div>
                                        <div>
                                            Valid Holding Account: Revenue
                                            Department pairs
                                        </div>
                                        <div class="font-weight-bold">
                                            Ha: Rd
                                        </div>
                                        @for (
                                            param of item.resultParameters;
                                            track param
                                        ) {
                                            <div>{{ param }}</div>
                                        }
                                    </div>
                                }
                            </li>
                        }
                    </ul>
                </div>
            }
            @if (importResult.validationNotification.warnings.length > 0) {
                <div class="mt-2">
                    <div class="row mt-2 mb-2">
                        <div class="col">
                            <span
                                >{{
                                    importResult.validationNotification.warnings
                                        .length
                                }}
                                {{ "CampImport.WarningsCount" | translate }}
                            </span>
                            <button
                                class="btn btn-primary btn-action ml-2 warnings-button"
                                (click)="onToggleWarningsClicked()"
                            >
                                @if (!showWarnings) {
                                    <span>{{
                                        "CampImport.ShowWarningsLabel"
                                            | translate
                                    }}</span>
                                }
                                @if (showWarnings) {
                                    <span>{{
                                        "CampImport.HideWarningsLabel"
                                            | translate
                                    }}</span>
                                }
                            </button>
                        </div>
                    </div>
                    @if (showWarnings) {
                        <div>
                            <strong class="text-warning">{{
                                "CampImport.WarningsLabel" | translate
                            }}</strong>
                        </div>
                    }
                    @if (showWarnings) {
                        <ul>
                            @for (
                                item of importResult.validationNotification
                                    .warnings;
                                track item
                            ) {
                                <li>{{ item.message }}</li>
                            }
                        </ul>
                    }
                </div>
            }
        </div>
    }
</div>
